/**
 * 
 * Questionnaire
 * 
 */


import React, { useEffect, useState } from 'react';
import { Grid, Typography, Link } from '@material-ui/core';
import styles from './styles';
import QuestionnaireForm from '../../components/QuestionnaireForm';
import api from '../../Utils/api';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import Verification from '../Verification/Verification';
import styled from 'styled-components';
import Introduction from '../Introduction/Introduction';
import ClipLoader from 'react-spinners/ClipLoader';
import store2 from 'store2';
import Snackbar from '../../components/Snackbar';
import withQueryParams from 'react-router-query-params';
import { compose } from 'redux';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { destroy } from 'redux-form';
import { extractResponses, getQuestionsCount, mergeQuestions } from './utils';
import FormLibrary from './Components/FormLibrary';
import { uploadFile } from '../../Utils/api';
import { getAnsweredQuestionsCount } from './utils';


const ClipWrapper = styled.div`
  text-align: center;
  margin-top: 100px
`;


function Questionnaire(props) {
    const { history, queryParams = {}, dispatch } = props;
    const { TargetLanguageCode } = queryParams;
    const classes = styles();
    const [record, setRecord] = useState(false);
    const [questionsData, setQuestionsData] = useState(false);
    const [answerData, setAnswerData] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [showTitle, setShowTitle] = useState(true);
    const [showQuestionnaire, setShowQuestionnaire] = useState(false);
    const [answeredCount, setAnsweredCount] = useState(0);
    const [busy, setBusy] = useState(false);
    const [showVerification, setShowVerification] = useState(false);
    const [resendCount, setResendCount] = useState(0);
    const [lawFirm, setLawFirm] = useState(false);
    const questionCategory = questionsData && questionsData?.length > 0 && questionsData[0] && questionsData[0]?.question_category && questionsData[0]?.document_type && questionsData[0]?.document_type.toLowerCase() === 'odd' || false;
    const questions = questionCategory ? lodash.groupBy(questionsData, 'question_category_id') : lodash.groupBy(questionsData, 'question_number_text') || {};

    const [masstortQuestionsRecords, setMasstortQuestionsRecords] = useState(false);
    const [clientData, setClientData] = useState(false);
    const [existingQuestions, setExistingQuestions] = useState(false);
    const [clientRecord, setClientRecord] = useState(false);
    const [otpSent, setOtpSent] = useState(false);

    useEffect(() => {

        const otp = store2.get('otp');
        const token = store2.get('token');
        const previousTimestamp = store2.get('previous_timestamp')
        const clientAnswered = store2.get('client_answered')
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (otp && token === props.match.params.token) {
            if (currentTimestamp && previousTimestamp && (currentTimestamp - previousTimestamp > 3600)) {
                store2.remove('otp')
                setShowVerification(true);
            } else {
                handleVerification(otp);
            }
        } else {
            if (previousTimestamp && clientAnswered && token !== props.match.params.token) {
                store2.remove('previous_timestamp');
                store2.remove('client_answered');
            }
            setShowVerification(true);
        }
    }, []);

    useEffect(() => {
        verifyOTP();
    }, []);

    const sendOtp = async () => {
        setResendCount(resendCount => resendCount + 1);
        setBusy(true);
        await api.post(`rest/mass-tort/sent-otp`, Object.assign({}, { otp_code: props.match.params.token, TargetLanguageCode })).then((response) => {
            setShowVerification(true);
            setOtpSent(true);
        }).catch((error) => {
            history.push(`/`);
            setError(error);
        }).finally(() => {
            setBusy(false);
        });
    }

    const verifyOTP = async () => {
        try {
            const response = await api.post(`/rest/mass-tort/verify-otp-code`, {
                otp_code: props.match.params.token,
            });
            const clientData = response?.data;
            setClientRecord(clientData);
        } catch (error) {
            if (error.response) {
                const backendMessage = error?.response?.data?.error;
                if (backendMessage == 'This url is no longer valid.') {
                    history.push(`/link-expired`);
                }
            }
        } finally {
            setBusy(false);
        }
    };

    const getActiveQuestions = (questions, activeQuestionsRecord) => {

        let panelIds = {};
        let quesIds = [];
        activeQuestionsRecord && activeQuestionsRecord.length && activeQuestionsRecord.forEach((ele) => {
            if (ele && ele?.questionType == 'panel') {
                panelIds = Object.assign({}, panelIds, { [ele.panelId]: ele?.questionId })
            } else {
                quesIds = quesIds.concat(ele?.questionId);
            }
        });

        const modifiedData = questions && questions.length && questions?.map((ques) => {
            if (ques && ques?.type == 'panel') {
                if (ques?.panelId && Object.keys(panelIds).includes(ques?.panelId)) {
                    return {
                        ...ques,
                        elements: ques?.elements?.filter((e) => panelIds[ques?.panelId].includes(e?.questionId))
                    }
                }
            } else {
                if (ques && quesIds.includes(ques?.questionId)) {
                    return ques;
                }
            }
        }).filter(Boolean);
        return modifiedData;
    }

    const [selectedQuestionsData, setSelectedQuestionsData] = useState([]);

    const verificationApi = async (securityCode) => {
        console.log('securityCode', securityCode, props.match.params.token);
        setBusy(true);
        await api.get(`/rest/mass-tort-form-builder/otp-details?otp_code=${props.match.params.token}&otp_secret=${securityCode}`).then(async (response) => {
            store2.set('otp', securityCode);
            store2.set('token', props.match.params.token);
            console.log('RRR', response.data);
            const responseData = response.data;

            console.log('responseData', responseData);

            setClientData(responseData);

            const fetchQuestionsResult = await api.post(`rest/mass-tort-client-forms/merged-questions-id-datas`, Object.assign({}, {
                practice_id: responseData?.practice_id,
                case_id: responseData?.case_id,
                client_id: responseData?.client_id
            })).then((response) => response.data).catch((error) => Promise.reject(error));

            console.log('fetchQuestionsResult', fetchQuestionsResult);
            setSelectedQuestionsData(fetchQuestionsResult?.selected_questions_data || []);



            if (fetchQuestionsResult && fetchQuestionsResult?.is_questions_merge_required) {
                if (fetchQuestionsResult?.is_client_forms_available) {

                    const selectedQuestionPublicUrl = fetchQuestionsResult && fetchQuestionsResult?.form_builder_data && fetchQuestionsResult?.form_builder_data?.public_url;

                    //   const selectedQuestionsRecord = yield call(downloadQuestionsJson, selectedQuestionPublicUrl);

                    const selectedQuestionsRecord = await api.get(selectedQuestionPublicUrl).then((res) => res.data).catch((Err) => Err);

                    console.log('questionsRecord', selectedQuestionsRecord);

                    const selectedQuestions = fetchQuestionsResult && fetchQuestionsResult?.selected_questions_data || [];

                    const lastSelectedQuestions = getActiveQuestions(selectedQuestionsRecord?.elements, selectedQuestions);
                    console.log('lastSelectedQuestions', lastSelectedQuestions);

                    const existingFormQustionsUrl = fetchQuestionsResult && fetchQuestionsResult?.client_forms_data && fetchQuestionsResult?.client_forms_data?.questions_public_url;

                    //   const existingQuestions = yield call(downloadQuestionsJson, existingFormQustionsUrl);

                    const existingQuestions = await api.get(existingFormQustionsUrl).then((res) => res.data).catch((Err) => Err);
                    console.log('existingQuestions', existingQuestions)
                    const existingQuestionsRecord = existingQuestions && existingQuestions?.result || existingQuestions || {};

                    const clientResponseData = existingQuestions && existingQuestions?.answers || existingQuestions?.responsedQuestions && existingQuestions?.responsedQuestions?.answers || existingQuestionsRecord && extractResponses(existingQuestionsRecord) || {};
                    setAnswerData(clientResponseData);

                    console.log('existingQuestionsRecord', existingQuestionsRecord);

                    const mergedWithCurrentQuestions = mergeQuestions(existingQuestionsRecord, lastSelectedQuestions);
                    console.log('mergedWithCurrentQuestions', mergedWithCurrentQuestions);

                    await api.post(`rest/mass-tort-client-forms`, Object.assign({}, {
                        case_id: responseData?.case_id,
                        client_id: responseData?.client_id,
                        selected_questions_data: fetchQuestionsResult?.selected_questions_data
                    })).then(async (response) => {
                        const createFormResult = response && response?.data;
                        console.log('createFormResult111', createFormResult);

                        if (createFormResult) {
                            await uploadFile(createFormResult?.questions_upload_url, { result: mergedWithCurrentQuestions, answers: clientResponseData }, 'application/json');

                            const answeredCount = getAnsweredQuestionsCount(mergedWithCurrentQuestions);
                            const questionsCount = getQuestionsCount(mergedWithCurrentQuestions);

                            await api.put(`/rest/mass-tort-client-forms/save-s3key-url`, Object.assign({}, {
                                client_id: responseData?.client_id,
                                case_id: responseData?.case_id,
                                questions_public_url: createFormResult?.questions_public_url,
                                questions_s3_file_key: createFormResult?.questions_s3_file_key,
                                selected_questions_data: fetchQuestionsResult?.selected_questions_data,
                                answered_count: answeredCount || 0,
                                questions_count: questionsCount || 0
                            })).then((response) => response.data).catch((error) => Promise.reject(error));

                            setMasstortQuestionsRecords(mergedWithCurrentQuestions);
                            setShowVerification(false);
                            setBusy(false);

                        }
                    }).catch((error) => Promise.reject(error));


                } else {
                    const questionPublicUrl = fetchQuestionsResult && fetchQuestionsResult?.form_builder_data && fetchQuestionsResult?.form_builder_data?.public_url;

                    //   const questionsRecord = yield call(downloadQuestionsJson, questionPublicUrl);

                    const questionsRecord = await api.get(questionPublicUrl).then((res) => res.data).catch((Err) => Err);

                    console.log('questionsRecord', questionsRecord);
                    const selectedQuestions = fetchQuestionsResult && fetchQuestionsResult?.selected_questions_data || [];

                    const currentActiveQuestions = getActiveQuestions(questionsRecord?.elements, selectedQuestions);
                    console.log('currentActiveQuestions', currentActiveQuestions);

                    await api.post(`rest/mass-tort-client-forms`, Object.assign({}, {
                        case_id: responseData?.case_id,
                        client_id: responseData?.client_id,
                        selected_questions_data: fetchQuestionsResult?.selected_questions_data
                    })).then(async (response) => {
                        const createFormResult = response && response?.data;
                        console.log('createFormResult', createFormResult);

                        if (createFormResult) {
                            await uploadFile(createFormResult?.questions_upload_url, currentActiveQuestions, 'application/json');

                            const answeredCount = getAnsweredQuestionsCount(currentActiveQuestions);
                            const questionsCount = getQuestionsCount(currentActiveQuestions);
                            console.log('QQQQQ', questionsCount);
                            await api.put(`/rest/mass-tort-client-forms/save-s3key-url`, Object.assign({}, {
                                client_id: responseData?.client_id,
                                case_id: responseData?.case_id,
                                questions_public_url: createFormResult?.questions_public_url,
                                questions_s3_file_key: createFormResult?.questions_s3_file_key,
                                selected_questions_data: fetchQuestionsResult?.selected_questions_data,
                                answered_count: answeredCount,
                                questions_count: questionsCount
                            })).then((response) => response.data).catch((error) => Promise.reject(error));

                            setMasstortQuestionsRecords(currentActiveQuestions);
                            setShowVerification(false);
                            setBusy(false);

                        }
                    }).catch((error) => Promise.reject(error));
                    //   const formResult = yield call(createClientForms, record);
                    //   console.log('formResult', formResult);

                    //   yield call(uploadFile, formResult?.questions_upload_url, currentActiveQuestions, 'application/json');

                    //   const saveFormData = yield call(saveQuestionsUrl, Object.assign({}, {
                    //     client_id : record?.client_id, 
                    //     case_id: record?.case_id, 
                    //     questions_public_url: formResult?.questions_upload_url, 
                    //     questions_s3_file_key: formResult?.questions_s3_file_key,
                    //     selected_questions_data: fetchQuestionsResult?.selected_questions_data
                    //   }));

                }
            } else {
                const getClientFormQuestionsUrl = fetchQuestionsResult && fetchQuestionsResult?.client_forms_data && fetchQuestionsResult?.client_forms_data?.questions_public_url;

                const questionsRecord = await api.get(getClientFormQuestionsUrl).then((res) => res.data).catch((Err) => Err);

                const clientFormQuestions = questionsRecord && questionsRecord?.result || questionsRecord || {}

                console.log('clientFormQuestions', clientFormQuestions);


                const clientResponseData = questionsRecord && questionsRecord?.answers || questionsRecord?.responsedQuestions && questionsRecord?.responsedQuestions?.answers || clientFormQuestions && extractResponses(clientFormQuestions) || {};
                setAnswerData(clientResponseData);

                const activeQuestions = fetchQuestionsResult && fetchQuestionsResult?.form_builder_data && fetchQuestionsResult?.form_builder_data?.active_questions_data && fetchQuestionsResult?.form_builder_data?.active_questions_data?.activeQuestions;

                console.log('AAA', activeQuestions);


                const activeQuestionsResult = getActiveQuestions(clientFormQuestions?.elements || clientFormQuestions, activeQuestions);

                await api.post(`rest/mass-tort-client-forms`, Object.assign({}, {
                    case_id: responseData?.case_id,
                    client_id: responseData?.client_id,
                    selected_questions_data: fetchQuestionsResult?.selected_questions_data
                })).then(async (response) => {
                    const createFormResult = response && response?.data;
                    console.log('createFormResult', createFormResult);
                    console.log('activeQuestionsResult', activeQuestionsResult);

                    if (createFormResult) {
                        let updatedQuestions = activeQuestionsResult;
                        if (fetchQuestionsResult?.is_client_forms_available) { //To merge JSON with answer's.
                            updatedQuestions = Object.assign({}, {
                                result: activeQuestionsResult,
                                answers: clientResponseData
                            })
                        };
                        console.log('updatedQuestions', updatedQuestions)
                        await uploadFile(createFormResult?.questions_upload_url, updatedQuestions, 'application/json');

                        const answeredCount = getAnsweredQuestionsCount(activeQuestionsResult);
                        const questionsCount = getQuestionsCount(activeQuestionsResult);
                        console.log('QQQQQ', questionsCount);

                        await api.put(`/rest/mass-tort-client-forms/save-s3key-url`, Object.assign({}, {
                            client_id: responseData?.client_id,
                            case_id: responseData?.case_id,
                            questions_public_url: createFormResult?.questions_public_url,
                            questions_s3_file_key: createFormResult?.questions_s3_file_key,
                            selected_questions_data: fetchQuestionsResult?.selected_questions_data,
                            questions_count: questionsCount,
                            answered_count: answeredCount
                        })).then((response) => response.data).catch((error) => Promise.reject(error));

                        setMasstortQuestionsRecords(activeQuestionsResult);
                        setShowVerification(false);
                        setBusy(false);

                    }
                }).catch((error) => Promise.reject(error));



            }
            // setClientData(responseData);

            // const {active_questions_data = {} } = responseData;
            // const activeQuestionsRecord = active_questions_data && Object.keys(active_questions_data).length && active_questions_data?.activeQuestions || false;

            // if(responseData && responseData?.answered_questions_set_public_url){
            //     const existingQuestionsData = await api.get(responseData?.answered_questions_set_public_url).then((res) => res.data).catch((Err) => Err);
            //     const activeQuestions = getActiveQuestions(existingQuestionsData?.result, activeQuestionsRecord);
            //     setExistingQuestions(activeQuestions);
            // }

            // const questionsRecord = await api.get(responseData?.questions_set_public_url).then(res => res.data).catch(err => err);
            // console.log('questionsRecord', questionsRecord);
            // if (questionsRecord) {
            //     const questionsContent = questionsRecord && questionsRecord?.result || questionsRecord;
            //     const responsesData = questionsRecord && questionsRecord?.answers || {};
            //     setAnswerData(responsesData);
            //     const activeQuestions = getActiveQuestions(questionsContent, activeQuestionsRecord);
            //     setMasstortQuestionsRecords(activeQuestions);
            //     setShowVerification(false);
            //     setBusy(false);
            // }
        }).catch((error) => {
            //history.push(`/`);
            console.log('error', error);

            const Err = error && error.response && error.response.data && error.response.data.error && typeof error.response.data.error === 'string' ? error.response.data.error === `Invalid OTP` ? TargetLanguageCode === 'es' ? 'El código ingresado no es válido. Inténtalo de nuevo.' : TargetLanguageCode === 'vi' ? `Mã đã nhập không hợp lệ. Vui lòng thử lại.` : `Entered code is not valid. Please try again.` : error.response.data.error : "Entered code is not valid. Please try again.";
            setBusy(false);
            setError(Err);
        }).finally(() => {
            // setBusy(false);
        });
    }

    const handleVerification = (securityCode) => {
        verificationApi(securityCode);
    }

    const handleVerify = (securityCode) => {
        verificationApi(securityCode);
        // const currentTimestamp = Math.floor(Date.now() / 1000);
        // store2.set('previous_timestamp', currentTimestamp);
    }

    if (busy && !showQuestionnaire) {
        return <ClipWrapper>
            <ClipLoader color={"#2ca01c"} />
        </ClipWrapper>
    }

    console.log('showVerification', showVerification);

    return (
        <Grid container>
            {showVerification ? <Verification handleVerify={handleVerify} error={error} sendOtp={sendOtp} resendCount={resendCount} otpSent={otpSent} clientRecord={clientRecord} /> :
                <FormLibrary
                    selectedQuestionsData={selectedQuestionsData}
                    clientData={clientData}
                    answerData={answerData || {}}
                    masstortQuestionsRecords={masstortQuestionsRecords}
                    existingQuestions={existingQuestions}
                />}
        </Grid>
    );
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        dispatch
    }
}

export default compose(
    connect(mapDispatchToProps),
    withQueryParams()
)(Questionnaire);
